module.exports = __webpack_public_path__ + "static/media/24.964a8abd.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/24.png
// module id = 391
// module chunks = 0